import { render } from "./SysNotice.vue?vue&type=template&id=4f06c5dc"
import script from "./SysNotice.vue?vue&type=script&lang=js"
export * from "./SysNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__